export const consumptionDevicesUploadFilesModule = {
  state: {
    fileURLs: {},
    files: {},
    initialized: false,
    newCDFileUploaded: false,
  },
  mutations: {
    setConsumptionDeviceFiles(state, { key, files }) {
      if (!Array.isArray(files)) {
        files = [files];
      }
      state.files[key] = files;
    },
    addConsumptionDeviceFiles(state, { key, id, files }) {
      if (!state.files[key]) {
        state.files[key] = {}; // Initialize the key if not present
      }

      if (!state.files[key][id]) {
        state.files[key][id] = []; // Initialize the specific ID if not present
      }

      if (!Array.isArray(files)) {
        files = [files];
      }

      // Add files to the specific ID under the 'key'
      state.files[key][id] = [...state.files[key][id], ...files];
    },
    setConsumptionDeviceFileURL(state, object) {
      state.fileURLs[object.imageName] = object.url;
    },
    setConsumptionDeviceFileHistoryFromBackend(state, fileObject) {
      state.files[fileObject.name] = fileObject;
    },
    setConsumptionDeviceFilesInitialized(state, value) {
      state.initialized = value;
    },
    removeConsumptionDeviceFile(state, imageName) {
      delete state.files[imageName];
    },
    removeConsumptionDeviceFileWithKey(state, { key, imageName }) {
      if (state.files[key] && Array.isArray(state.files[key])) {
        const fileIndex = state.files[key].findIndex(
          (file) => file.name === imageName
        );
        if (fileIndex !== -1) {
          state.files[key].splice(fileIndex, 1);
        } else {
          console.error(`File ${imageName} not found in ${key}.`);
        }
      }
    },
    setCDFileChanged(state, newFileUploaded) {
      state.newCDFileUploaded = state.newCDFileUploaded || newFileUploaded;
    },
    resetCDFileChanged(state) {
      state.newCDFileUploaded = false;
    },
    resetConsumptionDevicesUploadFilesModule(state) {
      Object.assign(state, JSON.parse(JSON.stringify(state)));
    },
  },
  getters: {
    getCDUploadFiles: (state) => {
      return state.files;
    },
    getConsumptionDeviceFileFromBackend: (state) => (imageName) => {
      return state.files[imageName];
    },
    getConsumptionDeviceFileURLByName: (state) => (imageName) => {
      return state.fileURLs[imageName];
    },
    getConsumptionDeviceFilesInitialized: (state) => {
      return state.initialized;
    },
    getCDFileChanged(state) {
      return state.newCDFileUploaded;
    },
  },
  actions: {},
};
